var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVervecard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#FFF5ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4345_185470)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4934 29.0045C23.4934 32.4285 20.7177 35.2042 17.2937 35.2042C13.8695 35.2042 11.0938 32.4285 11.0938 29.0045C11.0938 25.5805 13.8695 22.8048 17.2937 22.8048C20.7177 22.8048 23.4934 25.5805 23.4934 29.0045Z",
    fill: "#ED342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2951 31.6602C15.9083 28.5168 14.8915 25.5803 14.8915 25.5803H12.7656C12.7656 25.5803 14.0595 29.3493 16.463 34.0627H18.1271C20.5306 29.3493 21.8245 25.5803 21.8245 25.5803H19.6986C19.6986 25.5803 18.6818 28.5168 17.2951 31.6602Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9991 28.6812C42.7973 28.6812 42.705 29.9753 42.705 29.9753H45.2929C45.2929 29.9753 45.2006 28.6812 43.9991 28.6812ZM46.8644 31.2693H42.705C42.705 31.2693 42.7973 32.6559 44.6461 32.6559C45.5703 32.6559 46.4947 32.3784 46.4947 32.3784L46.6797 33.8573C46.6797 33.8573 45.7553 34.2272 44.4612 34.2272C42.6125 34.2272 40.9487 33.3028 40.9487 30.7147C40.9487 28.6812 42.2429 27.3871 44.0915 27.3871C46.8644 27.3871 47.0492 30.1601 46.8644 31.2693ZM32.7208 29.0852L33.0071 27.559C33.0071 27.559 30.797 26.8884 29.0008 28.1312V34.2359H30.9084V29.2758C31.6715 28.7037 32.7208 29.0852 32.7208 29.0852ZM24.7692 28.6812C23.5676 28.6812 23.4752 29.9753 23.4752 29.9753H26.0632C26.0632 29.9753 25.9709 28.6812 24.7692 28.6812ZM27.6345 31.2693H23.4752C23.4752 31.2693 23.5676 32.6559 25.4162 32.6559C26.3403 32.6559 27.2648 32.3784 27.2648 32.3784L27.4498 33.8573C27.4498 33.8573 26.5253 34.2272 25.2313 34.2272C23.3826 34.2272 21.7188 33.3028 21.7188 30.7147C21.7188 28.6812 23.0129 27.3871 24.8615 27.3871C27.6345 27.3871 27.8192 30.1601 27.6345 31.2693ZM37.3763 31.9027C36.4077 29.5778 35.9235 27.3882 35.9235 27.3882L33.9866 27.3885C33.9866 27.3885 34.9552 31.1277 36.6018 34.2261H38.1508C39.7976 31.1277 40.7662 27.389 40.7662 27.389H38.8291C38.8291 27.389 38.345 29.5778 37.3763 31.9027Z",
    fill: "#03435F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    stroke: "#FECBAA",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4345_185470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 12.5455,
    fill: "white",
    transform: "translate(11 22.7273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVervecard);
export default __webpack_public_path__ + "static/media/vervecard.c6c4dcb765282f089a1ae3df2edf444d.svg";
export { ForwardRef as ReactComponent };